import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { Classes } from '@blueprintjs/core';
import * as RadixPopover from '@radix-ui/react-popover';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import { usePopperJsPositioning } from './utils.js';

var _excluded = ["children", "defaultPadding", "className", "content", "defaultOpen", "onOpenChange", "open", "offset", "placement", "contentWrapperProps", "minimal"];
var Popover = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$defaultPadding = _ref.defaultPadding,
      defaultPadding = _ref$defaultPadding === void 0 ? true : _ref$defaultPadding,
      className = _ref.className,
      content = _ref.content,
      defaultOpen = _ref.defaultOpen,
      onOpenChange = _ref.onOpenChange,
      open = _ref.open,
      offset = _ref.offset,
      placement = _ref.placement,
      contentWrapperProps = _ref.contentWrapperProps,
      _ref$minimal = _ref.minimal,
      minimal = _ref$minimal === void 0 ? true : _ref$minimal,
      otherTriggerProps = _objectWithoutProperties(_ref, _excluded);

  // custom positioning via react-popper
  var _usePopperJsPositioni = usePopperJsPositioning({
    content: content,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange,
    open: open,
    placement: placement,
    className: cx(className, _defineProperty({}, Classes.POPOVER_CONTENT_SIZING, defaultPadding)),
    arrowType: minimal ? "none" : "default",
    offset: offset,
    triggerRef: ref,
    contentWrapperProps: contentWrapperProps
  }),
      rootProps = _usePopperJsPositioni.rootProps,
      triggerProps = _usePopperJsPositioni.triggerProps,
      contentProps = _usePopperJsPositioni.contentProps;

  return /*#__PURE__*/React__default.createElement(RadixPopover.Root, rootProps, /*#__PURE__*/React__default.createElement(RadixPopover.Trigger, _extends({}, otherTriggerProps, triggerProps), children), /*#__PURE__*/React__default.createElement(RadixPopover.Content, contentProps));
});

export { Popover };
//# sourceMappingURL=popover.js.map
